<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="ViewRecord" />
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
        this.$router.push("/quotation-edit/" + this.params.data.ref).catch(() => {})
    },
    ViewRecord () {
        this.$router.push("/quotation/" + this.params.data.ref).catch(() => {})
    }
  }
}
</script>
